import { CommonModule } from '@angular/common';
import { CustomizeTimePickerComponent } from './customize-time-picker.component';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { NzTimePickerModule } from 'ng-zorro-antd/time-picker';

@NgModule({
    declarations: [CustomizeTimePickerComponent],
    imports: [
        CommonModule,
        FormsModule,
        NzTimePickerModule,
    ],
    exports: [CustomizeTimePickerComponent],
})
export class CustomizeTimePickerModule {}
